// import { Edit } from '@mui/icons-material'
import { Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { formatHoraDataLocal } from "util/date";
import { formatHorarioString } from "util/string";
import ButtomEditNewReuniao from "./ButtomEditNewReuniao";

import DialogNovaReuniao from "./DialogNovaReuniao";
import { Delete } from "@mui/icons-material";
import { usePainelContext } from "./PainelContext";

const variantTy = "subtitle2";

const colorPresente = "rgba(135, 217, 135,1)";
const colorInscrito = "rgba(127, 191, 255,1)";
const colorSaiu = "rgba(255, 127, 127, 1)";
const colorAusente = "rgba(188, 188, 188, 1)";
const colorPendenteInscricao = "rgba(238, 248, 151, 1)";
// const colorHorariosPassados = "rgba(117, 49, 0, 0.5)"

const HeaderReunioes = () => {
    let corUsar = "rgba(255, 255, 255, 0.3)";

    return (
        <Box
            sx={{
                backgroundColor: corUsar,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                width: 600,
                display: "flex",
                flex: 1,
                gap: 2,
                height: 35,
                m: 1,
            }}
        >
            <div style={{ flex: 1, display: "flex",padding: 8, justifyContent: "center" }}>
                {/* <Typography variant='caption'>Mesa</Typography> */}
                <Typography variant={variantTy}>{"Mesa"}</Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", padding: 8,justifyContent: "center" }}>
                {/* <Typography variant='caption'>Participante 1</Typography> */}
                <Typography variant={variantTy}>{"Participante 1"}</Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex",padding: 8, justifyContent: "center" }}>
                {/* <Typography variant='caption'>Participante 2</Typography> */}
                <Typography variant={variantTy}>{"Participante 2"}</Typography>
            </div>
            <div style={{ width: 75, display: "flex", alignItems: "center" }}></div>
        </Box>
    );
};

const CardHora = ({ mesa, horario, reunioes, inscricoes, rodada, overSaveReuniao, deleteOnCard }) => {
    let corUsar = "rgba(255, 255, 255, 0.3)";
    // let status
    let reuniao = null;
    reuniao = (reunioes || []).find((r) => r.mesa?.uid === mesa.uid && r.horario?.horario === horario.horario);

    // PENDENTE NÃO AGENDA, MAS SE JÁ TIVER SIDO AGENDADO APARECE
    let ancoraMesa = (inscricoes || []).find((i) => i.mesa?.uid === mesa.uid && i.status === "INSCRITO");

    let incri1 = null;
    // let incri2 = null

    // // horários passados
    // if (new Date(horario.horario) < new Date()) {
    //     corUsar = colorHorariosPassados
    // }
    // else {
    // reunião marcada (inscrição 1 e 2)

    const getCorIncricao = (ins) => {
        let corInscri = "rgba(255, 255, 255, 0.3)";
        if (ins) {
            if (ins.statusEvento === "PENDENTE/INSCRICAO") {
                corInscri = colorPendenteInscricao;
            } else if (ins.statusEvento === "SAIU") {
                corInscri = colorSaiu;
            } else if (ins.statusEvento === "AUSENTE") {
                corInscri = colorAusente;
            } else if (ins.statusEvento === "INSCRITO") {
                corInscri = colorInscrito;
            } else if (ins.statusEvento === "PRESENTE") {
                corInscri = colorPresente;
            } else {
                corInscri = "rgba(30,30,235,0.0)";
            }
        }
        return corInscri;
    };
    if (reuniao) {
        incri1 = reuniao.inscricao1;
        // incri2 = reuniao.inscricao1
        // if (reuniao.inscricao2.statusEvento === "SAIU"
        //     || reuniao.inscricao1.statusEvento === "SAIU"
        // ) {
        //     corUsar = "rgba(222, 241, 48, 0.5)"
        // } else {
        //     corUsar = "rgba(125,125,125,0.2)"
        // }
        if (incri1) {
            if (
                reuniao.inscricao1.status === "PENDENTE/INSCRICAO" ||
                reuniao.inscricao2.status === "PENDENTE/INSCRICAO"
            ) {
                corUsar = colorPendenteInscricao;
            } else if (reuniao.inscricao1.statusEvento === "SAIU" || reuniao.inscricao2.statusEvento === "SAIU") {
                corUsar = colorSaiu;
            } else if (reuniao.inscricao1.statusEvento === "AUSENTE" || reuniao.inscricao2.statusEvento === "AUSENTE") {
                corUsar = colorAusente;
            } else if (
                reuniao.inscricao1.statusEvento === "INSCRITO" ||
                reuniao.inscricao2.statusEvento === "INSCRITO"
            ) {
                corUsar = colorInscrito;
            } else if (
                reuniao.inscricao1.statusEvento === "PRESENTE" &&
                reuniao.inscricao2.statusEvento === "PRESENTE"
            ) {
                corUsar = colorPresente;
            } else {
                corUsar = "rgba(30,30,235,0.0)";
            }
        }
    } else {
        incri1 = ancoraMesa;

        // ancora sozinho na mesa
        if (ancoraMesa) {
            // if (ancoraMesa.statusEvento === 'SAIU' || ancoraMesa.statusEvento === 'AUSENTE' || ancoraMesa.status === "PENDENTE/INSCRICAO") {
            //     corUsar = "rgba(222, 241, 48, 0.5)"
            // if (ancoraMesa.status === "PENDENTE/INSCRICAO") {
            //     corUsar = colorPendenteInscricao
            // } else if (ancoraMesa.statusEvento === 'SAIU') {
            //     corUsar = colorSaiu
            // } else if (ancoraMesa.statusEvento === 'AUSENTE') {
            //     corUsar = colorAusente
            // } else if (ancoraMesa.statusEvento === 'INSCRITO') {
            //     corUsar = colorInscrito
            // } else if (ancoraMesa.statusEvento === 'PRESENTE') {
            //     corUsar = colorPresente
            // } else {
            //     corUsar = "rgba(30,30,235,0.0)"
            // }
        }

        // mesa sem participantes
        else {
            corUsar = "rgba(30,30,235,0.0)";
        }
    }
    // }
    return (
        <Box
            className="hoverStart"
            sx={{
                backgroundColor: corUsar,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                width: 600,
                display: "flex",
                flex: 1,
                gap: 2,
                // p: 1,
                m: 1,
                minHeight: 60,
            }}
        >
            <div style={{ flex: 1, display: "flex", padding: 8, justifyContent: "center" }}>
                <Typography variant={variantTy} sx={{ textAlign: "center" }}>
                    {
                        mesa.index
                            ? "MESA " + mesa.index // + " - "
                            : `MESA ${rodada.mesas.map((m) => m.uid).indexOf(mesa.uid) + 1}` // - `
                    }
                    {/* {reuniao.mesa.name} */}
                </Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", padding: 8, backgroundColor: getCorIncricao(incri1) }}>
                <Typography variant={variantTy}>
                    {incri1
                        ? incri1.status
                            ? incri1.status === "PENDENTE/INSCRICAO"
                                ? `${incri1.empresa.nomeEmpresaCracha} ${` - (${incri1.status})`}`
                                : incri1.statusEvento
                                ? incri1.statusEvento === "SAIU" || incri1.statusEvento === "AUSENTE"
                                    ? `${incri1.empresa.nomeEmpresaCracha} ${` - (${incri1.statusEvento})`}`
                                    : incri1.empresa.nomeEmpresaCracha
                                : incri1.empresa.nomeEmpresaCracha
                            : ""
                        : ""}
                </Typography>
            </div>

            <Divider orientation="vertical" flexItem />

            <div style={{ flex: 2, display: "flex", padding: 8, backgroundColor: getCorIncricao(reuniao?.inscricao2) }}>
                <Typography variant={variantTy}>
                    {reuniao && reuniao.inscricao2
                        ? `${reuniao.inscricao2?.empresa.nomeEmpresaCracha} ${
                              reuniao.inscricao2?.statusEvento === "SAIU"
                                  ? `- (${reuniao.inscricao2.statusEvento})`
                                  : ""
                          }`
                        : ""}
                </Typography>
            </div>
            <div
                className="showHover"
                style={{ width: 75, display: "flex", alignItems: "center", justifyContent: "end" }}
            >
                {reuniao && reuniao.inscricao1 && reuniao.inscricao2 ? (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <Tooltip title="CANCELAR">
                            <div>
                                <IconButton onClick={() => deleteOnCard(reuniao)}>
                                    <Delete />
                                </IconButton>
                            </div>
                        </Tooltip>
                        <Tooltip title="EDITAR">
                            <div>
                                <ButtomEditNewReuniao
                                    rodada={rodada}
                                    inscritos={inscricoes}
                                    reunioes={reunioes}
                                    initialValues={reuniao}
                                    overSaveReuniao={overSaveReuniao}
                                    editOnlyP2
                                />
                            </div>
                        </Tooltip>
                    </div>
                ) : (
                    <Tooltip title="NOVO">
                        <div>
                            <ButtomEditNewReuniao
                                rodada={rodada}
                                inscritos={inscricoes}
                                reunioes={reunioes}
                                editOnlyP2
                                overSaveReuniao={overSaveReuniao}
                                initialValues={{
                                    status: "ATIVO",
                                    rodada: rodada,
                                    horario: horario,
                                    inscricao1: ancoraMesa,
                                    mesa: mesa,
                                    horariotxt: formatHorarioString(horario.horario),
                                }}
                            />
                        </div>
                    </Tooltip>
                )}
            </div>
        </Box>
    );
};

export default function PainelDeReunioes({ rodada, overSaveReuniao, deleteOnCard, inscricoes, reunioes }) {
    console.log("PainelDeReunioes");
    const { mesas, possiveisReunioes } = rodada;

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                Legenda
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorInscrito, margin: 5 }} />
                    Alguém Inscrito
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorPresente, margin: 5 }} />
                    Ambos Presentes
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorSaiu, margin: 5 }} />
                    Saiu
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorAusente, margin: 5 }} />
                    Ausente
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorPendenteInscricao, margin: 5 }} />
                    Pendente/Inscricao
                </div>
                {/*
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorHorariosPassados, margin: 5 }} />
                    Horários Passados
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}><div style={{ height: 25, width: 25, backgroundColor: "rgba(30,30,235,0.5)", margin: 5 }} />Dísponível</div>
                <div style={{ display: 'flex', alignItems: 'center' }}><div style={{ height: 25, width: 25, backgroundColor: "rgba(125,125,125,0.2)", margin: 5 }} />Reunião Marcada</div>
                <div style={{ display: 'flex', alignItems: 'center' }}><div style={{ height: 25, width: 25, backgroundColor: "rgba(222, 241, 48, 0.5)", margin: 5 }} />Âncora Ausente, Saiu ou Pendente</div>
                <div style={{ display: 'flex', alignItems: 'center' }}><div style={{ height: 25, width: 25, backgroundColor: "rgba(255, 0, 0, 0.2)", margin: 5 }} />Horários Passados</div>
                */}
                <div style={{ paddingLeft: 25, display: "flex", alignItems: "center" }}></div>
                <div style={{ display: "flex" }}>
                    <DialogNovaReuniao
                        rodada={rodada}
                        inscritos={inscricoes}
                        reunioes={reunioes}
                        overSaveReuniao={overSaveReuniao}
                    />
                </div>
            </div>
            <div style={{ display: "flex" }}>
                <Box
                    sx={{ display: "flex", overflow: "auto", transform: "rotateX(180deg)", maxWidth: "96.5vw", mt: 2 }}
                >
                    <Box sx={{ display: "flex", transform: "rotateX(180deg)" }}>
                        {(possiveisReunioes || []).map((h, hi) => {
                            let horaFormat = formatHoraDataLocal(h.horario);
                            let bgColor = hi % 2 ? "#eee" : "#fff";
                            return (
                                <div key={hi} style={{ backgroundColor: bgColor }}>
                                    <Typography variant="h6" style={{ textAlign: "center" }}>
                                        {horaFormat}
                                    </Typography>
                                    <HeaderReunioes />
                                    {mesas.map((mesa, mi) => {
                                        return (
                                            <CardHora
                                                key={mi}
                                                horario={h}
                                                mesa={mesa}
                                                reunioes={reunioes}
                                                inscricoes={inscricoes}
                                                rodada={rodada}
                                                overSaveReuniao={overSaveReuniao}
                                                deleteOnCard={deleteOnCard}
                                            />
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </Box>
                </Box>
            </div>
        </div>
    );
}
